module.exports = __webpack_public_path__ + "static/media/drag_to_match.9333a16b.jpg";